import React from 'react';
import Performance from '../../../Pages/Performance';

export default function DashboardPerformanceSection({
    activeView,
    publicationPending = false,
    factorSliceScopeKey = null,
    onRegisterPublicationPreparation = null,
    optimalPortfolioOptimizer,
    optimalPortfolioSummary,
    setOptimalPortfolioOptimizer,
    setOptimalPortfolioSummary,
    listOfWhatIfPortfolios,
    fetchOptimizerPortfolios,
    setError,
    setShowPortfolioMetrics,
    clearOptimizedOverlay,
    unsavedOptimizerRun,
    setOptimizedRiskMetrics,
    matricesLoading,
    actualPortfolioIsReady,
    watchlistIsReady,
    actualPortfolioVersion,
    watchlistVersion,
    userUid,
    factorDatasetSelectionEnabled = false,
    factorContext,
    initialContextPending = false,
    initialContextFailed = false,
    onWatchlistRestorationStaged = null,
    compareExploreColumns = null,
    setCompareExploreColumns = null,
}) {
    return (
        <Performance
            activeView={activeView}
            publicationPending={publicationPending}
            factorSliceScopeKey={factorSliceScopeKey}
            onRegisterPublicationPreparation={onRegisterPublicationPreparation}
            optimalPortfolioOptimizer={optimalPortfolioOptimizer}
            optimalPortfolioSummary={optimalPortfolioSummary}
            setOptimalPortfolioOptimizer={setOptimalPortfolioOptimizer}
            setOptimalPortfolioSummary={setOptimalPortfolioSummary}
            listOfWhatIfPortfolios={listOfWhatIfPortfolios}
            fetchOptimizerPortfolios={fetchOptimizerPortfolios}
            setError={setError}
            setShowPortfolioMetrics={setShowPortfolioMetrics}
            clearOptimizedOverlay={clearOptimizedOverlay}
            unsavedOptimizerRun={unsavedOptimizerRun}
            setOptimizedRiskMetrics={setOptimizedRiskMetrics}
            matricesLoading={matricesLoading}
            actualPortfolioIsReady={actualPortfolioIsReady}
            watchlistIsReady={watchlistIsReady}
            actualPortfolioVersion={actualPortfolioVersion}
            watchlistVersion={watchlistVersion}
            userUid={userUid}
            factorDatasetSelectionEnabled={factorDatasetSelectionEnabled}
            factorContext={factorContext}
            initialContextPending={initialContextPending}
            initialContextFailed={initialContextFailed}
            onWatchlistRestorationStaged={onWatchlistRestorationStaged}
            compareExploreColumns={compareExploreColumns}
            setCompareExploreColumns={setCompareExploreColumns}
        />
    );
}
